// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"7364e275","255":"8dc6cfbf"}[chunkId] + ".chunk.css";
};